import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/xhs-assistant.webp'


const _hoisted_1 = { class: "smart-content-workshop" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "grid-content-left" }
const _hoisted_5 = { class: "grid-content-left-content" }
const _hoisted_6 = { class: "left-header" }
const _hoisted_7 = { class: "header-content" }
const _hoisted_8 = { class: "header-content-title" }
const _hoisted_9 = { class: "left-content" }
const _hoisted_10 = { class: "grid-content-right-content" }
const _hoisted_11 = { class: "menu" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "menu-item-text" }

import AiPolisherToolBar from '@/components/AiPolisherToolBar/index.vue';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { ref, onMounted, reactive, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ImageGenerator from '@/views/smartContentWorkshop/components/ImageGenerator.vue';
import ContentReviewer from '@/views/smartContentWorkshop/components/ContentReviewer.vue';
import { debounce } from 'lodash';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  typeName: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    default: '',
  },
},
  emits: ['goBack'],
  setup(__props, { emit: __emit }) {

const editorOption = reactive({
  theme: 'snow',
  placeholder: '请输入内容',
  modules: {
    toolbar: false, // 隐藏工具栏
  },
});

const props = __props;

const emit = __emit;

const currentData = ref({
  title: '',
  context: '',
  contextHtml: '',
  historyImageList: [],
});
const activeType = ref(''); // 当前类型
const showContent = ref(false); // 内容是否显示
const colSpan = ref(0); // 列宽
const isShowRightPanel = ref(false); // 右侧面板是否显示
const isTitleEdit = ref(false); // 标题编辑
const router = useRouter(); // 路由

const imageGeneratorRef = ref(null); // 图片生成器
const contentReviewerRef = ref(null); // 内容审查器
const aiPolisherRef = ref(null); // 智能助手

const myQuillEditor = ref(null); // 富文本编辑器
const selectedText = ref(''); // 选中文本

// 全屏预览
const isFullscreen = ref(false);
const currentImageUrl = ref('');

// 替换内容
const handleContentReviewerReplace = (violation: any, index: number) => {
  console.log(violation, index, 'violation');

  const { position, original, content } = violation;
  const editorContent = currentData.value.context;

  // Find the start index of the position in the content
  const startIndex = editorContent.indexOf(position);

  if (startIndex !== -1) {
    // Find the original text within the position
    const originalStartIndex = position.indexOf(original);

    if (originalStartIndex !== -1) {
      // Calculate the absolute start and end indices of the original text
      const absoluteStartIndex = startIndex + originalStartIndex;
      const absoluteEndIndex = absoluteStartIndex + original.length;

      // Replace the original text with the new content
      const newContent = editorContent.slice(0, absoluteStartIndex) + content + editorContent.slice(absoluteEndIndex);

      // Update the content in currentData
      currentData.value.context = newContent;

      // Update the HTML content if necessary
      if (currentData.value.contextHtml) {
        currentData.value.contextHtml = currentData.value.contextHtml.replace(original, content);
      }

      // Update the Quill editor content
      if (myQuillEditor.value) {
        myQuillEditor.value.setContents(newContent);
      }
      contentReviewerRef.value.handleContentReviewerReplaceSuccess(index);
      // Save the updated content to local storage
      saveLocalStorage();
    }
  }
};

// 全屏预览
const handleFullscreen = (imageUrl: string) => {
  isFullscreen.value = true;
  currentImageUrl.value = imageUrl;
};

// 删除图片
const handleDeleteImage = (imageUrl: string) => {
  console.log(imageUrl, 'imageUrl');
  const index = currentData.value.historyImageList.findIndex((item) => item === imageUrl);
  if (index !== -1) {
    currentData.value.historyImageList.splice(index, 1);
  }
  saveLocalStorage();
};

const handleFullscreenClose = () => {
  isFullscreen.value = false;
  currentImageUrl.value = '';
};

// 右侧菜单
const rightTopMenuList = ref([
  {
    name: '插图',
    icon: 'ri-image-add-line',
    type: 'image',
  },
  {
    name: '审查',
    icon: 'ri-file-shield-line',
    type: 'review',
  },
]);

// 生成图片
const handleNewImageGenerated = (imageUrl: string) => {
  (currentData.value.historyImageList as string[]).unshift(imageUrl);
  saveLocalStorage();
};

// 点击菜单
const handleClick = (item) => {
  activeType.value = item.type;
  showContent.value = true;
  changeRightPanelWidth(true);
};

// 收起
const handleCollapse = () => {
  changeRightPanelWidth(!isShowRightPanel.value);
};

let isComposing = ref(false);
const onEditorReady = (quill) => {
  quill.on('selection-change', (range, oldRange, source) => {
    handleSelectionChange(quill, range);
  });

  quill.root.addEventListener('compositionstart', () => {
    isComposing.value = true; // 开始输入拼音
  });

  quill.root.addEventListener('compositionend', () => {
    isComposing.value = false; // 输入拼音结束
    handleContentUpdate(quill.root.innerHTML); // 在输入结束后更新内容
  });
};
// 内容更新
const handleContentUpdate = debounce((content: string) => {
  console.log(11213121);

  if (myQuillEditor.value) {
    const quill = myQuillEditor.value.getQuill();
    var text = quill.getText();
    var html = quill.root.innerHTML;
    currentData.value.context = text;
    currentData.value.contextHtml = html;
    saveLocalStorage();
  }
}, 300);

const handleGenerateImage = async () => {
  activeType.value = 'image';
  showContent.value = true;
  changeRightPanelWidth(true);
  await nextTick();
  if (imageGeneratorRef.value) {
    imageGeneratorRef.value.initGenerate(selectedText.value);
  }
};

const handleInsert = (text: any) => {
  if (myQuillEditor.value) {
    const quill = myQuillEditor.value.getQuill();
    const range = quill.getSelection();
    if (range) {
      quill.insertText(range.index, text.content);
      quill.setSelection(range.index + text.content.length);
    } else {
      quill.insertText(quill.getLength(), text.content);
      quill.setSelection(quill.getLength());
    }
    handleContentUpdate(quill.root.innerHTML);
  }
};

const handleReplace = (text: any) => {
  if (myQuillEditor.value) {
    const quill = myQuillEditor.value.getQuill();
    const range = quill.getSelection();
    if (range) {
      quill.deleteText(range.index, range.length);
      quill.insertText(range.index, text.content);
      quill.setSelection(range.index + text.content.length);
      handleContentUpdate(quill.root.innerHTML);
    }
  }
};

const handleSelectionChange = (quill, range) => {
  const selection = quill.getSelection();
  if (selection && selection.length) {
    // 获取选区坐标
    const bounds = quill.getBounds(selection.index, selection.length);
    const editorBounds = quill.container.getBoundingClientRect();

    // 选区坐标
    const selectionCoords = {
      left: editorBounds.left + bounds.left,
      top: editorBounds.top + bounds.top,
      right: editorBounds.left + bounds.right,
      bottom: editorBounds.top + bounds.bottom,
      width: bounds.right - bounds.left,
      height: bounds.bottom - bounds.top,
    };

    const aiPolisherWidth = aiPolisherRef.value.tooltipWidth;
    const x = selectionCoords.left + selectionCoords.width / 2 - aiPolisherWidth / 2;
    const y = selectionCoords.bottom;

    selectedText.value = quill.getText(selection.index, selection.length);
    console.log(selectedText.value, 'selectedText');

    aiPolisherRef.value.showPopper();
    aiPolisherRef.value.handleGenerateGetBoundingClientRect(x, y);
  } else {
    aiPolisherRef.value.hidePopper();
  }
};

// 保存标题
const handleTitleSave = () => {
  console.log(currentData.value, 'currentData');
  if (!currentData.value) return;
  saveLocalStorage();
  isTitleEdit.value = false;
};

// 保存到本地
const saveLocalStorage = () => {
  const data = localStorage.getItem(props.typeName);
  if (!data) return null;

  const dataObj = JSON.parse(data);
  const index = dataObj.findIndex((item) => item.id === props.id);
  dataObj[index] = currentData.value;
  localStorage.setItem(props.typeName, JSON.stringify(dataObj));
};

// 从本地获取数据
const fetchDataFromLocalStorage = () => {
  const data = localStorage.getItem(props.typeName);
  if (!data) return null;

  console.log('data', data);

  const dataObj = JSON.parse(data);
  return dataObj.find((item) => item.id === props.id);
};

// 初始化
onMounted(async () => {
  const fetchedData = await fetchDataFromLocalStorage();
  console.log(fetchedData, 'fetchedData');
  if (fetchedData) {
    currentData.value = { ...currentData.value, ...fetchedData };
  }

  await nextTick();
  if (myQuillEditor.value) {
    myQuillEditor.value.setContents(currentData.value.contextHtml);
  }
});

const rightPanelWidth = ref(0); // 右侧面板宽度百分比

// 改变右侧面板宽度
const changeRightPanelWidth = (bool: boolean) => {
  isShowRightPanel.value = bool;
  rightPanelWidth.value = bool ? 500 : 0; // 25% 对应原来的 8 列宽度
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_page_header, {
                  onBack: _cache[2] || (_cache[2] = ($event: any) => (emit('goBack')))
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[5] || (_cache[5] = _createElementVNode("img", {
                        src: _imports_0,
                        alt: "小红书助手",
                        class: "header-content-img"
                      }, null, -1)),
                      _createElementVNode("div", _hoisted_8, [
                        (!isTitleEdit.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "header-content-title-text",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (isTitleEdit.value = true))
                            }, _toDisplayString(currentData.value?.title || '请输入标题'), 1))
                          : _createCommentVNode("", true),
                        (isTitleEdit.value)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 1,
                              class: "header-content-title",
                              modelValue: currentData.value.title,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentData.value.title) = $event)),
                              style: {"width":"200px"},
                              placeholder: "Please input",
                              onBlur: handleTitleSave
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  extra: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "flex items-center" }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(QuillEditor), {
                  ref_key: "myQuillEditor",
                  ref: myQuillEditor,
                  "content-type": "html",
                  content: currentData.value.context,
                  "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => ((currentData.value.context) = $event)),
                  options: editorOption,
                  onReady: onEditorReady
                }, null, 8, ["content", "options"])
              ])
            ])
          ]),
          (isShowRightPanel.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "grid-content-right",
                style: _normalizeStyle({ width: `${rightPanelWidth.value}px` })
              }, [
                _createElementVNode("i", {
                  class: "ri-arrow-right-s-line collapse-button",
                  onClick: handleCollapse
                }),
                _createElementVNode("div", _hoisted_10, [
                  (activeType.value === 'image')
                    ? (_openBlock(), _createBlock(ImageGenerator, {
                        key: 0,
                        ref_key: "imageGeneratorRef",
                        ref: imageGeneratorRef,
                        historyImageList: currentData.value.historyImageList,
                        onNewImageGenerated: handleNewImageGenerated,
                        onFullscreen: handleFullscreen,
                        onDeleteImage: handleDeleteImage
                      }, null, 8, ["historyImageList"]))
                    : _createCommentVNode("", true),
                  (activeType.value === 'review')
                    ? (_openBlock(), _createBlock(ContentReviewer, {
                        key: 1,
                        ref_key: "contentReviewerRef",
                        ref: contentReviewerRef,
                        content: currentData.value.context,
                        onReplace: handleContentReviewerReplace
                      }, null, 8, ["content"]))
                    : _createCommentVNode("", true)
                ])
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightTopMenuList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.type,
              onClick: ($event: any) => (handleClick(item)),
              class: "menu-item"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([item.icon, "menu-item-icon"])
              }, null, 2),
              _createElementVNode("span", _hoisted_13, _toDisplayString(item.name), 1)
            ], 8, _hoisted_12))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: isFullscreen.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isFullscreen).value = $event)),
      class: "fullscreen-preview",
      fullscreen: "",
      onClick: handleFullscreenClose,
      style: {"display":"flex","align-items":"center","justify-content":"center","overflow":"hidden"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_image, {
          fit: "contain",
          style: {"width":"100vw","height":"100vh"},
          src: currentImageUrl.value,
          alt: "Fullscreen Preview"
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(AiPolisherToolBar, {
      ref_key: "aiPolisherRef",
      ref: aiPolisherRef,
      selectedText: selectedText.value,
      showGenerateImage: true,
      onGenerateImage: handleGenerateImage,
      onInsert: handleInsert,
      onReplace: handleReplace
    }, null, 8, ["selectedText"])
  ], 64))
}
}

})